import React, { useCallback } from 'react'
import { useDispatch } from 'hooks/use-redux'
import { nextTrack } from '@disco/state-management/actions/MediaActions'
import PlayerButton from 'components/common/player/player-button'

/**
 * Player next track button component
 * Dispatches action to skip to the next track in the current playlist or queue
 */
const PlayerNext = (): any => {
  const dispatch = useDispatch()
  const handleClick = useCallback(() => {
    dispatch(nextTrack(false))
  }, [dispatch])
  return <PlayerButton onClick={handleClick} type="skip-forward" />
}

export default PlayerNext
